module.exports = __webpack_public_path__ + "img/img7.03e2bf19.svg";